export const orderPage = (index:number, page:number, total:string | number) => index + 1 + (page > 1 ? (page - 1) * Number(total) : 0);
